import { toast } from '@/components/toast/Toast';
import { HttpStatus } from '@/errors/http-status';
import { getSettings, updateSettings } from '@/services/api';
import { logger } from '@/services/logger';
import { useMutation, useQuery } from 'react-query';

export function useGetSettings(enabled: boolean = true) {
    return useQuery('agentSettings', getSettings, {
        enabled,
        retry: enabled ? 5 : false,
        retryDelay: 1000,
        onError: enabled
            ? async (error: any) => {
                  if (!handleMaxAllowedDomainsError(error)) {
                      logger.error('Could not get agent insight settings', { error });
                      toast.error({
                          title: 'Could not get agent insight settings',
                          toastId: 'agent-insights-setting-get-error',
                      });
                  }
              }
            : undefined,
    });
}
export function useUpdateSettings() {
    return useMutation(updateSettings, {
        retry: 5,
        retryDelay: 1000,
        onError: async (error: any) => {
            if (!handleMaxAllowedDomainsError(error)) {
                logger.error('Could not update agent insight settings', { error });
                toast.error({ title: `Could not update agent insight settings`, toastId: `agent-insights-setting-update-error` });
            }
        },
    });
}

function handleMaxAllowedDomainsError(error: any) {
    if (error.response?.status === HttpStatus.MAX_ALLOWED_DOMAINS_LIMIT_REACHED) {
        logger.error(error.response.data.description);
        toast.error({
            title: error.response.data.description,
            toastId: `agent-insights-setting-error`,
        });
        return true;
    }
    return false;
}
